import { defineMessages } from 'react-intl'

export default defineMessages({
  payPalLoadError: {
    id: 'app.error.payPalLoadError',
    defaultMessage: 'There was an error loading the PayPal library. Please refresh and try again.',
  },
})
